import { createReducer } from '../../utils/createReducer.ts';
import { createQuickButton } from '../../utils/messages.ts';
import { QuickButtonsActions, SET_QUICK_BUTTONS } from '../actions/types.ts';
import { QuickButtonsState, QuickButtonTypes } from '../types.ts';

const initialState = {
  quickButtons: []
};

const quickButtonsReducer = {
  [SET_QUICK_BUTTONS]: (_: QuickButtonsState, { buttons }) =>
    ({ quickButtons: [...buttons.map((button: QuickButtonTypes) => createQuickButton(button))] })
}

export default (state = initialState, action: QuickButtonsActions) => createReducer(quickButtonsReducer, state, action);
